import { useState, type FormEvent } from "react";

import type { AddTenantUserPayload } from "@/api/tenants";
import { Button, Ribbon } from "@/components/ui";
import { t } from "@/i18n";

interface AddUserFormProps {
  onSubmit: (payload: AddTenantUserPayload) => void;
  isSubmitting: boolean;
  error: string | null;
}

/** "Kullanıcı ekle" formu — /kullanicilar (gorev talimati madde 4). Sifre
 * alani KASITLI YOK: backend bos birakilirsa rastgele uretir ve BIR KEZ
 * doner (bkz. Kullanicilar.tsx'teki tek-seferlik-sifre paneli). */
export function AddUserForm({ onSubmit, isSubmitting, error }: AddUserFormProps) {
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [role, setRole] = useState<"tenant_admin" | "tenant_user">("tenant_user");

  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (!email.trim()) return;
    onSubmit({ email: email.trim(), first_name: firstName.trim(), last_name: lastName.trim(), role });
  }

  return (
    <form onSubmit={handleSubmit} className="card space-y-3">
      <h2 className="text-sm font-bold uppercase tracking-wide text-muted">{t("kullanicilar.add.title")}</h2>

      {error && <Ribbon tone="bad">{error}</Ribbon>}

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <label className="block">
          <span className="label">{t("kullanicilar.add.email")}</span>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="input" />
        </label>
        <label className="block">
          <span className="label">{t("kullanicilar.add.role")}</span>
          <select
            value={role}
            onChange={(e) => setRole(e.target.value as "tenant_admin" | "tenant_user")}
            className="input"
          >
            <option value="tenant_user">{t("kullanicilar.role.tenant_user")}</option>
            <option value="tenant_admin">{t("kullanicilar.role.tenant_admin")}</option>
          </select>
        </label>
        <label className="block">
          <span className="label">{t("kullanicilar.add.first_name")}</span>
          <input value={firstName} onChange={(e) => setFirstName(e.target.value)} className="input" />
        </label>
        <label className="block">
          <span className="label">{t("kullanicilar.add.last_name")}</span>
          <input value={lastName} onChange={(e) => setLastName(e.target.value)} className="input" />
        </label>
      </div>

      <Button type="submit" variant="primary" disabled={isSubmitting}>
        {t("kullanicilar.add.submit")}
      </Button>
    </form>
  );
}
